import { Box, Typography, Modal, Paper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setVmsStates, setVmsModal } from "../../../reduxApp/fieldStore";
import React from "react";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  display: "flex",
  border: "none",
  flexDirection: "column",
  boxShadow: 24,
  alignItems: "center",
  p: 4,
};
const DeleteModal = ({ deleteVmscell }) => {
  const dispatch = useDispatch();
  const employIntegration = useSelector((state) => state.dropedField);

  return (
    <Modal
      open={true}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Paper sx={style}>
        <span
          class="material-symbols-outlined"
          style={{ fontSize: "80px", color: "#cf4242", fontWeight: "600" }}
        >
          Delete
        </span>

        <Typography
          variant="h4"
          sx={{ fontWeight: "600", color: "#6C6C6C", margin: "10px" }}
        >
          Delete This Record ?
        </Typography>
        <Typography variant="p" sx={{ color: "#6C6C6C" }}>
          Do you really want to delete this record?{" "}
        </Typography>
        <Typography variant="p" sx={{ color: "#6C6C6C" }}>
          You will not able to recover it.
        </Typography>
        <Box display={"flex"} sx={{ margin: "25px" }}>
          <button
            onClick={() => {
              dispatch(setVmsModal(""));
              dispatch(
                setVmsStates({
                  vmsId: -1,
                  action: "",
                })
              );
            }}
            style={{
              color: "black",
              padding: "10px 35px",
              fontSize: "14px",
              border: "1px solid black",
              background: "white",
              borderRadius: "3px",
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              deleteVmscell(employIntegration.vmsStats.vmsId);
              dispatch(setVmsModal(""));
              dispatch(
                setVmsStates({
                  vmsId: -1,
                  action: "",
                })
              );
            }}
            style={{
              background: "#cf4242",
              borderRadius: "3px",
              marginLeft: "7px",
              border: "none",
              padding: "10px 35px",
              color: "white",
              fontSize: "14px",
            }}
          >
            Delete
          </button>
        </Box>
      </Paper>
    </Modal>
  );
};

export default DeleteModal;
